<template>
  <div class="bg-payment"></div>
</template>

<script>
export default {};
</script>

<style scoped>
.bg-payment {
  position: fixed;
  background-image: url('/img/programs/nes/lpBgTopVisual-blur.jpg');
  background-size: cover;
  background-position: center;
  top: 0;
  width: 100%;
  height: 100%;
}
@media (max-width: 767px) {
  .bg-payment {
    background-image: url('/img/programs/nes/lpBgTopVisual-small-blur.jpg');
  }
}
</style>
